// How a Brand reads wherever one is picked by name (#309): its Owner
// alongside, so two same-named Brands can be told apart. A Brand named after
// its own Owner (Neutrik owns Neutrik) reads as just the name. Where a Brand
// is only shown, not picked, it reads as just brand.name, with this label
// as its hover title.
export default function brandLabel(brand) {
  if (!brand) return '';
  const owner = brand.owner?.name;
  return owner && owner !== brand.name ? `${brand.name} (${owner})` : brand.name;
}

// The business itself as a Brand Owner (#430), held by Optim under this key.
export const THIS_BUSINESS_KEY = 'this_business';

export const isThisBusiness = (owner) => owner?.system_key === THIS_BUSINESS_KEY;

// How a Brand's Owner reads where the Owner itself is shown: the business
// as its company name followed by "(this business)".
export function ownerName(owner) {
  if (!owner) return '';
  return isThisBusiness(owner) ? `${owner.name} (this business)` : owner.name;
}

// Where the Owner chip opens: the business's own Company Information, else
// the Organisation's page.
export const ownerHref = (owner) => (isThisBusiness(owner) ? '/company-info' : `/commercial-entities/${owner.id}`);
